<template>
    <div class="bloque-general">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="bloque-general__encabezado">
                        <h2>Últimas noticias</h2>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-6">
                    <NoticiaBox :item="noticias[0]" :portada="true"
                        :clase="'tarjeta-noticia tarjeta-noticia--destacada'" :truncate="false" />
                </div>
                <div class="col-lg-6">
                    <NoticiaBox v-for="(item, index) in noticias.slice(1, 4)" style="margin-bottom: 20px;" :key="index" :item="item"
                        :truncate="false" />
                </div>
            </div>

            <div class="row text-center">
                <div class="col-md-12">
                    <div class="bloque-boton bloque-boton--pb-none">
                        <Link href="/noticias" class="boton-principal boton-flecha">Ver más noticias</Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import NoticiaBox from '../../Shared/Noticias/NoticiaBox.vue'

export default {
    props: {
        noticias: Object,
    },
    components: { Link, NoticiaBox }
}
</script>
